import { render, staticRenderFns } from "./generalization.vue?vue&type=template&id=dbda51d0"
import script from "./generalization.vue?vue&type=script&lang=js"
export * from "./generalization.vue?vue&type=script&lang=js"
import style0 from "./generalization.vue?vue&type=style&index=0&id=dbda51d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports